import { render, staticRenderFns } from "./MemberImportResultModal.vue?vue&type=template&id=2bb2434c&scoped=true&"
import script from "./MemberImportResultModal.vue?vue&type=script&lang=js&"
export * from "./MemberImportResultModal.vue?vue&type=script&lang=js&"
import style0 from "./MemberImportResultModal.vue?vue&type=style&index=0&id=2bb2434c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2434c",
  null
  
)

export default component.exports